
import Vue from "vue";
import { AuthService } from "@/services/auth.service";
import { container } from "@/services/container";
import { kebabCase } from "lodash";
const authService: AuthService = container.get("authService");

export default Vue.extend({
  name: "SideBar",
  components: {},
  data: () => ({
    isLoggedIn: false,
    menuGroups: [
      {
        name: "Admin",
        items: [
          {
            name: "Users",
            icon: "person-fill",
          },
          {
            name: "Accounts",
            icon: "people-fill",
          },
          {
            name: "Keys",
            icon: "tag-fill",
          },
          {
            name: "Metadata Manager",
            icon: "table",
          },
          {
            name: "Data Viewer",
            icon: "table",
          },
        ].map((i) => ({ ...i, link: kebabCase(i.name) })),
      },
      {
        name: "Gamma Web Services",
        items: [
          {
            name: "Services",
            icon: "bookmark-check",
          },
          {
            name: "Logs",
            icon: "card-text",
          },
          {
            name: "Usage",
            icon: "bar-chart-fill",
          },
          {
            name: "File Sharing",
            icon: "file-post",
          },
        ].map((i) => ({ ...i, link: kebabCase(i.name) })),
      },
    ],
  }),
  mounted() {
    this.checkAuthStatus();
  },
  methods: {
    checkAuthStatus() {
      authService
        .isAuthenticatedAsync()
        .then((isAuth: boolean) => (this.isLoggedIn = isAuth));
    },
  },
});
